import { useState } from 'react';
import { useFamilyStore } from '@/store/familyStore';
import { PersonalInfo } from '@/types';

export function useProfiles() {
  const { personalInfos = [], addPersonalInfo, updatePersonalInfo, deletePersonalInfo } = useFamilyStore();
  const [showAddDialog, setShowAddDialog] = useState(false);
  const [editingProfile, setEditingProfile] = useState<PersonalInfo | null>(null);
  const [deletingProfile, setDeletingProfile] = useState<PersonalInfo | null>(null);

  const handleAdd = (data: Omit<PersonalInfo, 'id'>) => {
    const newProfile = {
      id: crypto.randomUUID().replace(/[-]/g, ""),
      ...data,
      createdAt: Date.now(),
      updatedAt: Date.now(),
    };
    addPersonalInfo(newProfile);
    setShowAddDialog(false);
  };

  const handleEdit = (data: Omit<PersonalInfo, 'id'>) => {
    if (editingProfile) {
      updatePersonalInfo(editingProfile.id, {
        ...data,
        updatedAt: Date.now(),
      });
      setEditingProfile(null);
    }
  };

  const handleDelete = () => {
    if (deletingProfile) {
      deletePersonalInfo(deletingProfile.id);
      setDeletingProfile(null);
    }
  };

  return {
    profiles: personalInfos,
    showAddDialog,
    setShowAddDialog,
    editingProfile,
    setEditingProfile,
    deletingProfile,
    setDeletingProfile,
    handleAdd,
    handleEdit,
    handleDelete,
  };
}